import React, { Component, Fragment } from "react";
import "./Entryform.css";
import Container from "@material-ui/core/Container";
import subDays from "date-fns/subDays";
import { AsyncTypeahead } from "react-bootstrap-typeahead";
import "react-bootstrap-typeahead/css/Typeahead.css";
import Db from "./db";
import axios from "axios";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import { FormGroup, Form,Input } from "reactstrap";
import { DatePicker } from "@material-ui/pickers";
import Typography from "@material-ui/core/Typography";
import * as handler from "../Actions/main";
import { connect } from "react-redux";
// import queryString from "query-string";
import CustomizedProgressBars from "./spinner";
class Entryform2 extends Component {
  constructor(props) {
    super(props);

    this.state = {
      isLoading: false,
      isLoading2:true,
      errorTrainNO: "",
      errordoj: "",
      errorstationCode: "",
      multiple: false,
      options: [],
      isTypeaheadFocus: true,
      trainNO: "",
      doj: new Date(),
      stationCode: "",
      show: false,
      queryTrainNo:false,
      error:""
    };
  }
  componentDidMount() {
    this.props.resetOutlets();
    this.props.resetOrders();
    console.log("entryform2 mounted");
    if(this.props.match.params.trainNo){
     this.setState({
       isloading2:true,
       queryTrainNo:true 
     })
     axios
     .get(" https://api.confirmtkt.com/api/trains/search", {
       params: { text:this.props.match.params.trainNo}
     })
     .then(response => {
       const trainP = response.data.map(
         train => train.Key + "/ " + train.Value
       );
      console.log( trainP[0]);
       this.setState({
         trainNO: trainP[0],
         isLoading2: false,
         show:true
       });
     })
     .catch(error => {
       this.setState({
         isLoading2:false,
         error:"Failed While Fetching Data"
       });
     });


    }
  }

  _handleSearch = query => {
    this.setState({ isLoading: true });
    axios
      .get(" https://api.confirmtkt.com/api/trains/search", {
        params: { text: query }
      })
      .then(response => {
        const trainP = response.data.map(
          train => train.Key + "/ " + train.Value
        );

        this.setState({
          options: trainP,
          isLoading: false
        });
      })
      .catch(error => {
        this.setState({
          isLoading: true
        });
      });
  };

  handleOnChange = selected => {
    if (selected) {
      let selectedValue = [];
      selectedValue.push(selected);
      console.log(selected);
      this.setState({
        trainNO: selected,
        show: true,
        errorTrainNO: ""
      });
    } else {
      this.setState({
        show: false,
        trainNO: "",
        doj: new Date(),
        stationCode: "",
        errordoj: "",
        errorstationCode: ""
      });
    }
  };

  handleChange = event => {
    this.setState({ stationCode: event.target.value, errorstationCode: "" });
  };

  myChangeHandler = date => {
    // date = this.convert(date);
    this.setState({
      doj: date,
      errordoj: ""
    });
  };

  mySubmitHandler = event => {
    event.preventDefault();
  };

  changeTrain=()=>{
    this.setState({
      queryTrainNo:false,
      trainNO:"",
      
    })
  }




  convert = str => {
    var date = new Date(str),
      mnth = ("0" + (date.getMonth() + 1)).slice(-2),
      day = ("0" + date.getDate()).slice(-2);
    return [day, mnth, date.getFullYear()].join("-");
  };
  Check = () => {
    if (this.state.trainNO === "") {
      this.setState({
        errorTrainNO: "enter the train name / number"
      });
      return false;
    }

    if (this.state.doj === "") {
      this.setState({
        errordoj: "Please select the date of Journey"
      });
      return false;
    }
    if (this.state.stationCode === "") {
      this.setState({
        errorstationCode: "Please select the Station"
      });
      return false;
    }

    return true;
  };

  formSubmit = () => {
    if (this.Check()) {
      let date = this.convert(this.state.doj);
      this.props.history.push({
        pathname: "/food-booking/outlets",
        search:
          "?trainNO=" +
          this.state.trainNO +
          "&doj=" +
          date +
          "&stationCode=" +
          this.state.stationCode
      });
    }
  };

  render() {
    let placeHolderContent = "TrainNo/ TrainName";
   let minUserAgeDate = subDays(new Date(), 3);
  //  const parsed = queryString.parse(this.props.location.search);
   let result;
   if(this.state.isLoading2===false){
           if(this.state.error===""){
            result=  <Container maxWidth="sm" style={{ marginTop: "4em" }}>
            <Typography
              align="center"
              variant="h4"
              gutterBottom={true}
              color="primary"
            >
              Order Food In Train
            </Typography>
            <Form onSubmit={this.mySubmitHandler}>
              <FormGroup>
                  
              {
              this.state.queryTrainNo===false?
    
                <div>
                  <Grid container justify="flex-start" className="header-summary">
                    <Grid item xs={12} className="search-title">
                      {this.props.type}
                    </Grid>
                  </Grid>
    
                  <div className="search-input">
                    <Fragment>
                      <AsyncTypeahead
                        ref={ref => (this._typeahead = ref)}
                        {...this.state}
                        placeholder={placeHolderContent}
                        onSearch={this._handleSearch}
                        maxHeight="350px"
                        style={{ height: 50 }}
                        id="trainlist"
                        onChange={selected => {
                          this.handleOnChange(selected[0]);
                        }}
                      />
                    </Fragment>
                  </div>
                  {this.state.errorTrainNO !== "" ? (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      ERROR: {this.state.errorTrainNO}
                    </p>
                  ) : null}
                </div>
                 :
                 <div style={{position:"relative"}}>
                 <Input
            type="text"
            name="trainNo"
            value={this.state.trainNO}
            id="train"
            readOnly
            style={{ height: 50 }}
          ></Input>
           <Button  style={{position:"absolute",right:"6px",top:"7px"}} onClick={this.changeTrain}  size="small" variant="contained" color="primary" ><span style={{fontSize:"8px"}}>change trainNo</span></Button>
           {this.state.errorTrainNO !== "" ? (
                    <p style={{ color: "red", fontSize: "12px" }}>
                      ERROR: {this.state.errorTrainNO}
                    </p>
                  ) : null}
           </div>
                  }
    
    
              </FormGroup>
              {this.state.show === true && this.state.isLoading === false ? (
                <div>
                  <FormGroup>
                    Date of Journey
                    <Fragment>
                      <DatePicker
                        autoOk
                        style={{ width: "100%" }}
                        format="dd/MM/yyyy"
                       
                        value={this.state.doj}
                        onChange={this.myChangeHandler}
                        inputVariant="outlined"
                        minDate={minUserAgeDate}
                      />
                    </Fragment>
                    {this.state.errordoj !== "" ? (
                      <p style={{ color: "red", fontSize: "12px" }}>
                        ERROR: {this.state.errordoj}
                      </p>
                    ) : null}
                  </FormGroup>
                {this.state.trainNO!==""?
                  <Db
                    change1={this.myChangeHandler}
                    change2={this.handleChange}
                    trainNO={this.state.trainNO}
                    change3={this.mySubmitHandler}
                    errordoj={this.state.errordoj}
                    errorstationCode={this.state.errorstationCode}
                  />:
                  null
                }
                </div>
              ) : null}
    
              <FormGroup>
                <Typography align="center">
                  <Button
                    variant="contained"
                    onClick={this.formSubmit}
                    size="medium"
                    style={{
                      color: "white",
                      backgroundColor: "green",
                      width: "100%",
                      height: 50
                    }}
                  >
                    Search FOOD
                  </Button>
                </Typography>
              </FormGroup>
            </Form>
          </Container>
        
           }
           else {
            result = (
              <Container style={{ marginTop: "50%", textAlign: "center" }}>
                <span style={{ fontSize: "14px" }}> Failed while fetching </span>
              </Container>
            );
           }                  
   }
   else{ result = (
    <Container>
      <Typography
        variant="h5"
        color="textSecondary"
        align="center"
        style={{ marginBottom:175 }}
      >
     
      </Typography>
      <div style={{ textAlign: "center" }}>
        <CustomizedProgressBars />
      </div>
    </Container>
  );
     
   }


    return (
      result
    
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    resetOutlets: () => dispatch(handler.resetOutlets()),
    resetOrders: () => dispatch(handler.resetRecords())
  };
};
export default connect(
  null,
  mapDispatchToProps
)(Entryform2);
